"use client";

import React, { FC, ReactNode } from "react";
import cn from "classnames";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";

export type ExpandableElementProps = {
  isOpen?: boolean;
  transitionDuration?: string;
  onToggle?: (isOpen: boolean) => void;
  buttonElement: ReactNode;
  contentElement: ReactNode;
};

export const ExpandableElement: FC<ExpandableElementProps> = ({
  isOpen,
  transitionDuration = "0ms",
  onToggle,
  buttonElement,
  contentElement,
}) => {
  const isControlled = !!onToggle;

  return (
    <Disclosure defaultOpen={isOpen}>
      {({ open }) => {
        // In controlled mode, use isOpen from props; otherwise use internal state
        const currentOpen = isControlled ? isOpen : open;

        return (
          <>
            <DisclosureButton
              as="div"
              onClick={
                isControlled
                  ? (e: React.MouseEvent) => {
                      e.preventDefault();
                      onToggle(!currentOpen);
                    }
                  : undefined
              }
            >
              {buttonElement}
            </DisclosureButton>
            <div
              className={cn(
                "overflow-hidden transition-[max-height] ease-in-out",
                currentOpen ? "max-h-500" : "max-h-0",
              )}
              style={{ transitionDuration }}
              inert={!currentOpen}
              aria-hidden={!currentOpen}
            >
              {contentElement}
            </div>
          </>
        );
      }}
    </Disclosure>
  );
};
